import Api from "api/permission.api";
import {API} from "utils/api";

export const servicePermissionUpdateAction = async (id, action = 'is_active') => {
    const res = await API.post(Api.postAction.replace(':id', id), {action});
    return !!res;
}

export const servicePermissionDestroy = async (id) => {
    const res = await API.delete(Api.deleteDestroy.replace(':id', id));
    return !!res;
}

export const servicePermissionSave = async (data) => {
    try {
        let res = '';
        if (data?.id) res = await API.put(Api.putUpdate.replace(':id', data.id), data)
        else res = await API.post(Api.postCreate, data)

        return !!res;
    } catch (e) {
        return false
    }
}

export const servicePermissionItem = async (id) => {
    const res = await API.get(Api.getId.replace(':id', id))
    if (res) return res;
    return false;
}

export const servicePermissionOptionSave = async (params) => {
    const res = await API.post(Api.postOption.replace(':id', params.group_id), params)
    if (res) return res;
    return false;
}

export const servicePermissionOption = async (id) => {
    const res = await API.get(Api.getOption.replace(':id', id))
    if (res) return res;
    return false;
}
